module.exports = __webpack_public_path__ + "static/pot-spoon2-d55cbb1a23c0bbc02e0c1f664715b728.svg";